const HalfStar = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="31"
    viewBox="0 0 32 31"
    fill="none"
    className={className}
  >
    <path
      d="M16.0014 4.44435e-07C15.2304 -0.000490385 14.4592 0.405569 14.0627 1.21818L10.2894 8.95216L1.85205 10.1924C0.0800853 10.4528 -0.627437 12.6556 0.654759 13.9199L6.7601 19.9399L5.31883 28.4404C5.07924 29.8535 6.18983 31.001 7.44925 31C7.78193 31.0003 8.12506 30.9204 8.4565 30.7441L16.0016 26.7316L23.5466 30.7441C25.1315 31.587 26.9839 30.2256 26.6812 28.4404L25.2399 19.9399L31.3452 13.9199C32.6274 12.6556 31.9199 10.4528 30.1479 10.1924L21.7106 8.95216L17.9373 1.21817C17.5415 0.406946 16.7711 0.000888718 16.0014 4.44435e-07C16.001 7.84964e-09 16.0018 6.85266e-07 16.0014 4.44435e-07ZM16.0025 24.2711V2.73917L19.6139 10.1412C19.9286 10.7862 20.5369 11.2333 21.2405 11.3367L29.3215 12.5245L23.474 18.2903C22.9649 18.7923 22.7325 19.5157 22.8527 20.2246L24.2331 28.366L17.0053 24.5221C16.6914 24.3552 16.347 24.2715 16.0025 24.2711Z"
      fill="currentColor"
    />
  </svg>
);

export default HalfStar;
